<template>
<div class='vx-col w-full mt-4'>
    <div class="botonera">
        <vs-button @click="f_agregar()" color="primary">Agregar</vs-button>
    </div>
    <vs-popup :title="tituloModal" :active.sync="modalAgregar">
        <TiposVue v-if="modalAgregar" :tipoAccion="tipoAccion" :datosEditar="datosEditar" @changeData="changeData" />
    </vs-popup>
    <vs-table :data="listaTipos" class="mt-4">
        <template slot="thead">
            <vs-th>Nombre</vs-th>
            <vs-th>Detalle</vs-th>
            <vs-th>Acciones</vs-th>
        </template>
        <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="tr.nombre">
                    {{tr.nombre | title}}<br>
                    {{tr.created_at | formatoFecha}} <br>
                    <vs-chip v-if="tr.estado == 0 ">Inactivo</vs-chip>
                    <vs-chip v-if="tr.estado == 1" color='success'>Activo</vs-chip>
                </vs-td>
                <vs-td :data="tr.nombre">
                    {{tr.descripcion}}
                </vs-td>
                <vs-td>
                    <vs-button @click="f_editar(tr)" icon=edit color="warning"></vs-button>
                </vs-td>
            </vs-tr>
        </template>
    </vs-table>
</div>
</template>

<script>
import GeneralMixin from '@/mixins/GeneralMixin';
import TiposVue from './formulario.vue';
export default {
    mixins: [GeneralMixin],
    name: 'ListaTipos',
    components: {
        TiposVue
    },
    data() {
        return {
            listaTipos: [],
            modalAgregar: false,
            tipoAccion: 0, //0 agregar - 1 editar
            datosEditar: {},
            tituloModal:'',
        };
    },
    created() {},
    mounted() {
        let me = this;
        me.f_get_tipos();
    },
    methods: {
        f_get_tipos() {
            let me = this;
            me.$vs.loading();
            me.$http.get(this.$server_url + 'tiposGames')
                .then(function (response) {
                    console.log(response.data);
                    me.listaTipos = response.data;
                    me.$vs.loading.close();
                })
                .catch(function () {
                    me.f_notificaciones("No se obtuvo datos desde la DB", "danger");
                    me.$vs.loading.close();
                })
        },
        f_agregar() {
            let me = this;
            me.tipoAccion = 0; //agregar
            me.tituloModal = 'Agregar';
            me.modalAgregar = true;
        },
        f_editar(item) {
            let me = this;
            me.tipoAccion = 1; //agregar
            me.datosEditar = item;
            me.tituloModal = 'Editar';
            me.modalAgregar = true;
        },
        changeData() {
            let me = this;
            me.f_get_tipos();
            me.modalAgregar = false;
        }
    }
};
</script>
